import React from 'react';
import { Grid2 as Grid, Stack, Typography } from '@mui/material';
import { FormattedTextField, TextField } from 'framework/ui/field';
import { FollowUpField } from 'domain/shared/core/dashboard';
import { StyledGrid } from '../../dashboard/List/StaffingProjectItemCollapsed';
import IssuesStaffingDashboardField from '../../dashboard/shared/fields/IssuesStaffingDashboardField';
import StaffingDashboardAssignCoordinatorField from '../../dashboard/shared/fields/StaffingDashboardAssignCoordinatorField';
import StaffingDashboardZoneChangeButton from '../../dashboard/shared/fields/StaffingDashboardZoneChangeButton';
import { AppIconLabel } from 'framework/ui/mui-builder';
import { EMPTY_VALUE_INDICATOR, formatDecimal } from 'framework/utils';
import { IconLabel } from './OpportunityDashboardGeneralInfo';

interface OpportunityDashboardCollapsedItemProps {
  accountPath: string;
  crmId?: string;
  accountName?: string;
  accountId?: string;
  assignedFte?: number;
}

const OpportunityDashboardCollapsedItem: React.FC<OpportunityDashboardCollapsedItemProps> = ({
  crmId,
  accountName,
  accountId,
  assignedFte,
}) => {
  return (
    <Grid
      container
      className="dashboard-card-content"
      columns={12}
      spacing={2}
      justifyContent="space-between"
      alignItems="center"
    >
      <StyledGrid size={1} display="flex">
        <TextField value={crmId} label="" />
      </StyledGrid>
      <StyledGrid size={2} display="flex" color={'neutral'}>
        <TextField value={`${accountName} - ${accountId}`} label="" />
      </StyledGrid>
      <StyledGrid size={1} display="flex" flexDirection="row">
        <FormattedTextField
          value={assignedFte ? `${formatDecimal(assignedFte)} FTE` : EMPTY_VALUE_INDICATOR}
          format={(str: string) => {
            return (
              <Stack direction="row" alignItems="center">
                <IconLabel>
                  <AppIconLabel icon="group" tooltipTitle="Expected FTE" />
                </IconLabel>
                <Typography>{str}</Typography>
              </Stack>
            );
          }}
        />
      </StyledGrid>
      <StyledGrid size={{ xs: 1.5 }}>
        <FollowUpField source="staffingRisk.followUps" />
      </StyledGrid>

      <StyledGrid size={{ xs: 3.5 }}>
        <IssuesStaffingDashboardField />
      </StyledGrid>

      <StyledGrid size={{ xs: 2 }} sx={{ pl: 2 }}>
        <StaffingDashboardAssignCoordinatorField />
      </StyledGrid>

      <StyledGrid size={{ xs: 1 }}>
        <StaffingDashboardZoneChangeButton
          buttonSx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
        />
      </StyledGrid>
    </Grid>
  );
};

export default OpportunityDashboardCollapsedItem;
